import { NoQuotationIcon } from "components/ui/icons/quotations/NoQuotationIcon"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import style from "./NoQuotations.module.scss"

const { noQuotations, iconAndText, button } = style

type Props = {
	createQuotation: () => void
	canActAsOwner: boolean
}

export const NoQuotations = ({ createQuotation, canActAsOwner }: Props) => {
	return (
		<div className={noQuotations}>
			<div className={iconAndText}>
				<NoQuotationIcon />
				<p>No quotations were created for this file yet.</p>
			</div>
			{canActAsOwner && (
				<ButtonPrimary className={button} onClick={createQuotation}>
					Create quotation
				</ButtonPrimary>
			)}
		</div>
	)
}
